/**
 * GrowthPage — Growth 2.0 Dashboard (fallback/admin route)
 * Primary access: /marketing → Growth tab
 * Fallback access: /growth (this page)
 */
import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { MainLayout } from "@/components/layout/MainLayout";
import GrowthDashboardContent from "@/components/dashboard/GrowthDashboardContent";

export default function GrowthPage() {
  const { authAxios } = useAuth();

  return (
    <MainLayout>
      <GrowthDashboardContent authAxios={authAxios} showHeader={true} showPeriodSelector={true} />
    </MainLayout>
  );
}
